<footer class="page-footer">
  <div class="py-3 text-center small">
    <a routerLink="/legal/imprint">{{ 'IMPRINT' | translate }}</a> •
    <a routerLink="/legal/data-privacy">{{ 'DATA_PRIVACY' | translate }}</a>
  </div>
</footer>
